import i18next from 'i18next'
import { loadingAsyncState } from 'widgets-for-react'
import { TypeCastingValidator, canSafelyCast } from '../../../../utils/safe-type-casting'
import { componentTeaserValidator } from '../../components/componentTeasers/componentTeasersApi'
import { imageValidator } from '../../image/imageApi'
import { GuestChefHighlight } from './guestChefHighLight.state'

export const loadGuestChefHighlight = (id: number) =>
  loadingAsyncState(() =>
    getGuestChef(id).then((raw) => {
      const validationResult = canSafelyCast<GuestChefHighlight>(
        guestChefValidator,
        raw
      )
      return validationResult.kind == 'r'
        ? { kind: 'result', value: validationResult.v, status: 200 }
        : { kind: 'failed', status: 404 }
    })
  )

async function getGuestChef(id: number): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(
    `/api/v1/guest-chef?Id=${id}&language=${i18next.language}`,
    { method: 'get', headers: headers }
  )
  if (!res.ok) throw Error(res.statusText)
  return await res.json()
}

export const guestChefValidator: TypeCastingValidator<GuestChefHighlight> = {
  kind: 'object',
  fieldsValidator: {
    firstName: { kind: 'string' },
    lastName: { kind: 'string' },
    introduction: { kind: 'string' },
    image: imageValidator,
    components: {
      kind: 'array',
      elementValidator: componentTeaserValidator,
    },
  },
}
